import { useState, useEffect } from "react";
import Modal from "../dashboard/Modal"; // adjust path as needed

export default function HighlightModal({
  book, 
  isOpen, 
  onClose, 
  onSave, 
  initialHighlight = null 
}) {
  const [formData, setFormData] = useState({
    highlightType: "BOOK_OF_THE_MONTH",
    startDate: "",
    endDate: "",
  });

  useEffect(() => {
    if (initialHighlight) {
      setFormData({
        highlightType: initialHighlight.highlightType,
        startDate: initialHighlight.startDate.slice(0,16),
        endDate: initialHighlight.endDate.slice(0,16),
      });
    } else {
      setFormData({
        highlightType: "BOOK_OF_THE_MONTH",
        startDate: "",
        endDate: "",
      });
    }
  }, [initialHighlight]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({
      bookId: book.bookId,
      ...formData,
    });
  };

  return (
    <Modal show={isOpen} onClose={onClose} title={`Manage Highlights for "${book.bookName}"`}>
      <form onSubmit={handleSubmit} className="space-y-6">
        
        {/* Highlight Type */}
        <div>
          <label htmlFor="highlightType" className="block text-sm font-semibold text-gray-700">
            Highlight Type
          </label>
          <select
            id="highlightType"
            name="highlightType"
            value={formData.highlightType}
            onChange={handleChange}
            className="mt-1 block w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF7236] focus:border-transparent"
            required
          >
            <option value="BOOK_OF_THE_MONTH">Book of the Month</option>
          </select>
        </div>

        {/* Start Date */}
        <div>
          <label htmlFor="startDate" className="block text-sm font-semibold text-gray-700">
            Start Date & Time
          </label>
          <input
            id="startDate"
            name="startDate"
            type="datetime-local"
            value={formData.startDate}
            onChange={handleChange}
            className="mt-1 block w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF7236] focus:border-transparent"
            required
          />
        </div>

        {/* End Date */}
        <div>
          <label htmlFor="endDate" className="block text-sm font-semibold text-gray-700">
            End Date & Time
          </label>
          <input
            id="endDate"
            name="endDate"
            type="datetime-local"
            value={formData.endDate}
            onChange={handleChange}
            className="mt-1 block w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF7236] focus:border-transparent"
            required
          />
        </div>

        {/* Actions */}
        <div className="flex gap-4 justify-end pt-2">
          <button
            type="submit"
            className="bg-[#FF7236] text-white px-5 py-2 rounded-md hover:bg-[#D74A0E] transition"
          >
            {initialHighlight ? "Update Highlight" : "Add Highlight"}
          </button>
          <button
            type="button"
            onClick={onClose}
            className="bg-gray-200 text-black px-5 py-2 rounded-md hover:bg-gray-300 transition"
          >
            Cancel
          </button>
        </div>
      </form>
    </Modal>
  );
}
